export default "__VITE_ASSET__B7SVakZ9__"